import { PartnerNotesData } from 'store/partnerNotes';
import useGetPartnerNotes from '../useGetPartnerNotes';

export default function useGetMobilePartnerNotesItems(
  partnerNotesData?: PartnerNotesData,
) {
  const partnerNotes = partnerNotesData ?? useGetPartnerNotes();

  return Object.values(partnerNotes).sort((a, b) => {
    const dateA = new Date(a.kit.sample_date ?? 0);
    const dateB = new Date(b.kit.sample_date ?? 0);
    return dateB.getTime() - dateA.getTime();
  });
}
